import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader } from '@jsverse/transloco';

/**
 * Çeviri dosyalarını `assets/i18n/` altından yükler.
 * Global dosyalar: `assets/i18n/{lang}.json` (ör. `en.json`, `tr.json`).
 * Scope dosyaları: `assets/i18n/{scope}/{lang}.json` (ör. `customers/en.json`).
 * Transloco scope yüklemelerinde `lang` parametresini `customers/en` biçiminde verir.
 */
@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}
